/** API route map: URLS.Controller.CompanyBranch */
export const CompanyBranch = {
      Name: 'CompanyBranch/',
      Add: 'add',
      GetAll: 'get-all',
      Update: 'update',
};
